<template>
    <transition
        enter-active-class="transition duration-300"
        enter-from-class="transform opacity-0 scale-50 -translate-x-full"
        enter-to-class="transform opacity-100 scale-100 translate-x-0"
        leave-active-class="transition duration-300"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-50"

        mode="out-in"

        @after-leave="$emit('leave', null)"
    >
    <div class="overflow-hidden fixed md:top-20 top-2 right-5 z-50 shadow-md max-w-2xl"
        v-if="show"
    >
        <div
            class="font-medium border-2 px-4 py-3 text-sm w-100 rounded flex flex-col items-center justify-between"
            :class="{
                ['border-red-700 text-red-700 bg-red-100'] : $page.props.flash.error,
                ['border-green-700 text-green-700 bg-green-100'] : $page.props.flash.success,
            }"
        >
            <div class="flex items-center justify-between">
                <h5 class="font-semibold text-base mr-2"
                    v-html="$page.props.flash.error ? __( $page.props.flash.error, null, locale).replace(/\n/g, '<br />' ) :
                            ($page.props.flash.success ? __( $page.props.flash.success, null, locale).replace(/\n/g, '<br />' ) : __('Test message!', null, locale))"
                >
                </h5>
                <SvgIcon
                    name="x"
                    class="cursor-pointer"
                    height= "22"
                    width= "22"
                    @click="show = false"
                />
            </div>

        </div>
    </div>
    </transition>
</template>

<script>
    import SvgIcon from 'UI/SvgIcon';
    import { computed, onMounted, ref } from '@vue/runtime-core';
    import { usePage } from '@inertiajs/inertia-vue3';

    export default {
        components: {
            SvgIcon
        },
        props: ['locale'],
        emits: ['leave'],

        setup(props, { emit }) {
            const show = ref(false);

            const errors = computed(() => {
                return usePage().props.value.flash;
            }),
            hasErrors = computed(() => {
                return Object.keys(usePage().props.value.errors).length > 0;
            });

            onMounted(() => {
                show.value = true;
            });

            setTimeout(() => { show.value = false }, 10 * 1000);

            return {
                errors,
                hasErrors,
                show,
            }
        }
    }
</script>
